import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Uploads a file to object storage via admin endpoint, returns absolute URL.
export async function uploadMedia(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/media/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return `${BACKEND}${data.url}`;
}
